import MissingField from '../../filterQueryFormat/MissingField';
import fromDateRefinementFilter from './fromObjectSegFilter/fromDateRefinementFilter';
import fromNumberRefinementFilter from './fromObjectSegFilter/fromNumberRefinementFilter';
import toRefinementFilter from './toObjectSegFilter/toRefinementFilter';
import { DATE_REFINEMENT, NUMBER_REFINEMENT } from 'customer-data-filters-ui/converters/objectSeg/constants/constants';
export const tryAddMultipleRefinements = (operator, field, filter) => {
  if (MissingField.isMissingField(field)) {
    return operator;
  }
  const dateRefinement = fromDateRefinementFilter(field, filter);
  const numberRefinement = fromNumberRefinementFilter(field, filter);
  const refinedOperator = dateRefinement ? operator.set(DATE_REFINEMENT, dateRefinement) : operator;
  return numberRefinement ? refinedOperator.set(NUMBER_REFINEMENT, numberRefinement) : refinedOperator;
};
export const toMultipleRefinementFilter = operator => {
  const dateRefinement = operator.get(DATE_REFINEMENT);
  const numberRefinement = operator.get(NUMBER_REFINEMENT);
  let refinementFilter = {};
  if (dateRefinement) {
    refinementFilter = Object.assign({}, refinementFilter, toRefinementFilter(dateRefinement));
  }
  if (numberRefinement) {
    refinementFilter = Object.assign({}, refinementFilter, toRefinementFilter(numberRefinement));
  }
  return refinementFilter;
};